<template>


  <div id="caseStudies" @click="listenOut" :class="{ true: isShowing }" class="case homepageSec">

    <div id="innerNutshell">



       <div id="ourwork" class="grid grid__item_span-12 m0 p0 homepageSec" v-in-viewport>

          <div v-for="(slide, index) in list" :key="index" class="slide" :class="{ 'casestudies' : slide.type == 'casestudy'}" :id="'slide' + index" :style="'background-color:' + slide.backgroundColor +';'" v-in-viewport>
            <router-link :to="{ name: slide.slug.name, params: { slug: slide.slug.url, id: slide.slug.id }}" @click="setImage(index)" class="txtWhite">
              <div class="image" :style="'background-image: url(' + slide.featuredImage + ')'"></div>
              <!-- <img :src="slide.headerImageURL"/> --> 
              <div class="overlay" data-swiper-parallax="-700">
                <p class="txtWhite uppercase">
                  <span>{{slide.client}}.</span>
                </p>
                <h2 class="txtWhite">{{slide.title}}</h2>
                <p v-if="slide.type == 'casestudy'" class="tiny">View case study</p>
                <p v-else class="tiny">View project</p>
              </div>
            </router-link>
          </div>

        <div id="casestudyFooter" class="grid grid__item_span-12 p0 m0" v-in-viewport>
          <div class="inner grid grid__item_span-9">
            <h3 class="txtWhite grid grid__item_span-12 m0 p0">CTA TO POP HERE</h3>
            <router-link to="/services"><p class="txtWhite grid grid__item_span-12 m0 p0">Check out all our creative services.</p></router-link>
          </div>
        </div>
        

      </div>

    </div>

  </div>
</template>

<script>

// import {swiper, swiperSlide} from 'vue-awesome-swiper'
import Axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'
import pageAnimation from '../../assets/js/projectAnimation.js'
import menuTransitions from '../../assets/js/menu.js'
require('../../assets/js/settings.js')
require('swiper/dist/css/swiper.css')

export default {
  data () {
    return {
      isShowing: false,
      metaTitle: '',
      metaDescription: '',
      siteURL: window.url,
      swiperOption: {
        speed: 2000,
        initalSlide: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true
        }
      },
      list: [],
      nav: [],
      pageOrder: [
        '/',
        '/casestudies'
      ],
      navigationDirection: 'forward'
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription }
      ]
    }
  },
  methods: {
    listenOut () { // this is the function which closes the menu
      console.log('close menu')
      menuTransitions.hideHeader()
    },
    openContact () {
      this.isShowing = true
      this.$bus.$emit('openContact', {isShowing: true})  // Emit an event
    },
    RandomSlide () {
      // console.log(this.swiperOption.initialSlide)
      var firstSlide = Math.floor(Math.random() * 3)
      // console.log(firstSlide)
      this.swiperOption.initialSlide = firstSlide
    },
    animateLoad: function () {
      pageAnimation.animateCaseStudy()
    },
    setImage (index) {
      // console.log('clicked')
      var count = index
      console.log(count)
    },
    closeMenuDown () { // after timeout this closes menu
      setTimeout(function () {
        menuTransitions.hideHeader()
      }, 2800)
    },
    nextPage () {
      this.navigationDirection = 'forward'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const nextPage = this.pageOrder[currentPage + 1]
      // console.log(nextPage)
      if (nextPage) { this.$router.push(nextPage) }
    },
    prevPage () {
      this.navigationDirection = 'reverse'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const prevPage = this.pageOrder[currentPage - 1]
      if (prevPage) { this.$router.push(prevPage) }
    },
    processScroll (e) {
      if (e.deltaY < 0) {
        this.prevPage()
        // console.log('prevPage will load')
      }
      if (e.deltaY > 0) {
        this.nextPage()
        // console.log('nextPage will load')
      }
    },
    initScroll () {
      /* var mc = new hammer.Manager(window)
      var swipe = new hammer.Swipe()

      mc.add(swipe)
      mc.on('swipedown', ev => {
        this.prevPage()
      })
      mc.on('swipeup', ev => {
        this.nextPage()
      }) */

      var scrollTimer = 0
      var lastScrollFireTime = 0

      window.addEventListener('wheel', e => {
        if (this.pageOrder.indexOf(this.$route.path) + 1) {
          var minScrollTime = 1400
          var now = new Date().getTime()

          if (!scrollTimer) {
            if (now - lastScrollFireTime > minScrollTime) {
              this.processScroll(e) // fire immediately on first scroll
              lastScrollFireTime = now
            }
          }
        }
      })
    },
    isMenuOpen () { // on page load if menu is open it will close
      var pageHeader = document.getElementById('header')
      if (pageHeader.classList.contains('true')) {
        // console.log('yay')
        this.isShowing = true
      } else {
        document.getElementById('header').classList.remove('true')
        document.getElementById('movingHeader').classList.remove('true')
        document.getElementById('menuBtn').classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }
    }
  },
  created () {
    this.RandomSlide()
  },
  components: {
    // swiper,
    // swiperSlide
    'carousel': Carousel,
    'slide': Slide
  },
  beforeMount () {
  },
  mounted () {
    this.isMenuOpen()
    this.closeMenuDown()
    // this.initScroll()
    // this.listenOut() --> hide this to test out the open menu load page functionality

    Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/78').then(response => {
      this.metaTitle = response.data.acf.meta_title
      this.metaDescription = response.data.acf.meta_description
    }).catch(function (error) {
      console.log(error)
    })

    Axios.get(this.$root.$data.site + '/wp-json/wp/v2/casestudies/?per_page=100').then(response => {
      var list = response.data.map(obj => {
        return {
          title: obj.acf.project_title,
          client: obj.acf.client_name,
          cta: obj.acf.project_cta,
          type: obj.acf.project_type,
          id: obj.id,
          featuredImage: obj.acf.featured_image.url,
          slug: {
            name: 'Project',
            url: obj.slug,
            id: obj.id
          },
          headerImageURL: obj.acf.header_image.url,
          headerImageTxt: obj.acf.header_image.alt
        }
      })

      list.forEach(el => {
        this.list.push(el)
      })

      var nav = response.data.map(obj => {
        return {
          slug: obj.slug
        }
      })

      nav.forEach(el => {
        this.nav.push(el)
      })
    }).catch(function (error) {
      console.log(error)
    })
    this.animateLoad()
    // var caseStudies = document.getElementById('caseStudies')
    // caseStudies.style.opacity = 0
    // load page

    /* setInterval(() => {
      console.log('simulate async data')
      if (this.list.length < 10) {
        this.list.push(this.list.length + 1)
      }
    }, 3000) */
  },
  beforeDestroy () {
    window.addEventListener('wheel', e => {
      // console.log('removing wheel event listener')
    })
  },
  updated () {
    this.animateLoad()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landingSection{
    width: 100%;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/homepage/casestudies.vue